import styled, { css } from 'styled-components';
import { SectionHeading, Paragraph } from '../../global/typography';

export const StyledHeading = styled(SectionHeading)`
    text-align: center;

    & > span.--green {
        color: ${props => props.theme.colors.primary};
        display: block;
    }

    @media (max-width: 979px) {
        margin-bottom: 35px;
    }
`;

export const SliderControlDiv = styled.div`
    width: 100%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;

    @media (max-width: 979px) {
        font-size: 16px;
    }

    & > div {
        width: 8px;

        & > svg {
            width: 100%;
        }
    }
`;

export const PartnersSlide = styled.div`
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    margin-bottom: 5rem;

    @media (max-width: 979px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
`;

export const SliderSlide = styled.div`
    padding: 3.125rem 1rem;
    width: 100%;

    @media (max-width: 979px) {
        align-items: flex-start;
        padding: 3.125rem 0;
    }
`;
